import { render } from "./EditChampsLibreFamille.vue?vue&type=template&id=72c74904&ts=true"
import script from "./EditChampsLibreFamille.vue?vue&type=script&lang=ts"
export * from "./EditChampsLibreFamille.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__